<template>
  <div class="config-section">
    <div class="grid grid--container">
      <div class="config-section__content">
        <VText class="config-section__title" variant="h2">
          A Blazing Fast Bio Link Made Your Way
        </VText>
        <div class="config-section__text">
          <VText>
            Create with ease, customize with ease, and share with ease.
          </VText>
          <VText
            >Get a high conversion, mobile-optimized landing page setup in
            minutes.</VText
          >
        </div>
        <Button
          size="large"
          color="secondary"
          variant="hard-shadow"
          :href="buttonUrl"
        >
          Join for Free
        </Button>
      </div>
      <Config class="config-section__config" />
    </div>
  </div>
</template>

<script>
import { VText, Button } from '@campsite-bio/component-lib';
import Config from './config';

export default {
  components: {
    VText,
    Button,
    Config,
  },

  props: {
    buttonUrl: {
      type: String,
      default: 'https://app.campsite.bio/create-account',
    },
  },
};
</script>

<style lang="scss" scoped>
.config-section {
  padding-bottom: 5rem;
  padding-top: 5rem;
  overflow: hidden;
  text-align: center;

  @media (min-width: 992px) {
    padding-bottom: 5rem;
    padding-top: 10rem;
    text-align: left;
  }

  @media (min-width: 1100px) {
    padding-bottom: 10rem;
  }

  .grid {
    align-items: center;
    display: grid;

    @media (min-width: 992px) {
      grid-template-columns: 1fr 450px;
      gap: 3rem;
    }

    @media (min-width: 1100px) {
      grid-template-columns: 1fr 500px;
      gap: 5rem;
    }
  }

  &__content {
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 4rem;

    @media (min-width: 992px) {
      margin-bottom: 2rem;
      order: 1;
    }
  }

  &__text {
    margin-bottom: 2.5rem;

    p {
      font-size: 1.15rem;
      margin-bottom: 0.75em;

      @media (min-width: 768px) {
        font-size: 1.5rem;
      }
    }
  }

  &__config {
    max-width: 768px;
    margin-left: auto;
    margin-right: auto;
  }
}

.config-section__title.config-section__title {
  margin-bottom: 1.5rem;
  font-size: 2rem;

  @media (min-width: 768px) {
    font-size: 2.75rem;
  }
}
</style>
